import { useTranslation, type BillingSummary } from '@dukanti/shared';
import { formatBillingDate } from '../lib/billing-formatters';

export function BillingDiagnosticsCard({
  summary,
}: {
  readonly summary: BillingSummary;
}): React.JSX.Element {
  const { t, lang } = useTranslation();
  const subscription = summary.subscription;
  const emptyLabel = subscription
    ? t('admin.billing.diagnostics.empty')
    : t('admin.billing.diagnostics.notStarted');

  return (
    <section className="rounded-card border-sand-200 bg-paper border p-4 text-start shadow-sm">
      <h2 className="font-display text-sand-900 text-lg">{t('admin.billing.diagnostics.title')}</h2>
      <dl className="mt-4 grid gap-3 text-sm sm:grid-cols-2">
        <div>
          <dt className="text-sand-500">{t('admin.billing.diagnostics.environment')}</dt>
          <dd className="text-sand-800" dir="ltr">
            {subscription?.paypalEnvironment ?? emptyLabel}
          </dd>
        </div>
        <div>
          <dt className="text-sand-500">{t('admin.billing.diagnostics.lastSync')}</dt>
          <dd className="text-sand-800">
            {formatBillingDate(subscription?.lastPayPalSyncAt ?? null, lang) || emptyLabel}
          </dd>
        </div>
      </dl>
    </section>
  );
}
